module.exports = __webpack_public_path__ + "static/media/td.3a1f21d2.svg";